export default {
  ErrorEmailOrPassword: 'Error in email or password',
  ErrorSignInWithFacebook: 'This account is created with Facebook. Please make sure you are logged in with Facebook.',
  ErrorSignInWithApple: 'This account is set up with Apple. Make sure you sign in with Apple.',
  ErrorCouldNotValidate: 'An error occurred when validating your information'
}